import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import React, { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

import AlertsContext from "common/providers/alerts";
import TagForm from "./TagForm";

function Tag() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const { saveItem, updateItem, item, error, isFetching }: any = useItem(
    "tags",
    id
  );

  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate(-1);
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(
    async (dataTag: any) => {
      const tag = { ...dataTag };

      try {
        if (tag.id) {
          await updateItem(tag.id, tag);
        } else {
          await saveItem(tag);
        }
      } catch (e: any) {
        return e;
      }

      back();
      return true;
    },
    [updateItem, back, saveItem]
  );

  return isFetching || (id && !item) ? null : (
    <TagForm onSubmit={onSubmit} tag={item} />
  );
}

export default Tag;
